export default __webpack_public_path__ + "static/media/smm-360devpro.12fd3904.svg";